// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5896":"5854b637","8504":"1535db6f","9213":"5854b637"}[chunkId] + ".chunk.css";
};